import { StoreSkuItem } from "@playroomkit/pr-wars-data";
import { ItemImage } from "../ShopComponents";
import { useMemo } from "react";
import { useManager } from "@src/contexts/WarsContext";
import clsx from "clsx";

interface AvatarGridItemProps extends StoreSkuItem {
  onClick: (sku_id: string) => void;
  showPrice: (price: string | number) => string;
}

export const AvatarGridItem = (props: AvatarGridItemProps) => {
  const { sku_id, price, onClick, purchased, metadata, showPrice, free } =
    props;
  const manager = useManager();
  const player = manager.getMyPlayer();

  const label = useMemo(() => {
    if (player?.avatarId === metadata?.id) return "Equipped";
    if (free) return "Claimed";
    if (purchased) return "Purchased";
    if (!sku_id) return "Coming Soon";
    return null;
  }, [purchased, free, sku_id, player]);

  return (
    <div
      className={clsx("relative w-full max-h-[26rem] transition", {
        "hover:scale-105": !purchased,
      })}
      onClick={() => {
        if (purchased) return;
        onClick(sku_id ?? "");
      }}
    >
      <ItemImage
        src={metadata?.image ?? ""}
        className="w-full h-full object-contain"
      />
      {/* Price */}
      {(label || price) && (
        <div className="absolute bottom-5 text-shadow z-10 flex w-full items-center justify-center border-[#C369FF] text-white">
          {label ? (
            <span className="text-xl">{label}</span>
          ) : (
            <span className="text-3xl">{showPrice(price ?? "")}</span>
          )}
        </div>
      )}
    </div>
  );
};
